import { AuditFields, CommonFields, CommonStatus, PartnerRef, ValidAny } from "./common";
import { TargetSchema, ValidationError } from "./document";

export enum DocumentLoadStatus {
  SUCCESS = CommonStatus.SUCCESS,
  PARTIAL_SUCCESS = "partial_success",
  FAILED = CommonStatus.FAILED,
}

export enum LoadOperation {
  CREATED = "created",
  UPDATED = "updated",
  UNCHANGED = "unchanged",
}

interface NormalizationInfo {
  field: string;
  transformation: string;
  original_value: string;
  normalized_value: string;
}

export interface DocumentLoad extends CommonFields, AuditFields, PartnerRef {
  transformation_result_id_ref: string;
  status: DocumentLoadStatus;
  loaded_records: LoadedRecord[];
  failed_records?: FailedRecord[];
  normalization_warnings?: string[];
}

export interface LoadedRecord {
  target_schema: TargetSchema;
  operation: LoadOperation;
  entity_id_ref: string;
  fields_updated?: string[];
  normalization_applied?: NormalizationInfo[];
}

export interface FailedRecord {
  target_schema: TargetSchema;
  error: string;
  data?: Record<string, ValidAny>;
  validation_errors?: ValidationError[];
}
